import { getUrlCover } from '@libs/NwUtils';

//import pattern_waves from '@img/pattern2.png';
//import pattern_curly from '@img/pattern4.png';
import pattern_gray_tiles from '@img/pattern7.png';

const usePlaceholderImageFixed = (guid, contacttype) => {
    if ([4, 5].includes(contacttype) && guid) {
        return [getUrlCover(guid), false];
    }
    return [pattern_gray_tiles, true];
};

export default usePlaceholderImageFixed;
